export enum RedirectError {
  UNCOMPLETED_KYC = 'error_kyc_uncompleted',
  UNCOMPLETED_ROLLOVER = 'error_rollover_uncompleted',
}
